import { useMemo } from "react";
import { useRouterState } from "@tanstack/react-router";

const WORKFLOW_RE = /\/workflow\/([^/]+)/;

/**
 * Derive the active workflow id from the URL pathname instead of route params.
 *
 * REGRESSION GUARD: the `workflow/$workflowId` layout (and the screens it
 * wraps) stays mounted when navigating between workflows, so a param read at
 * mount goes stale — it keeps reporting the workflow that first mounted the
 * layout. Reading that stale value for tab navigation, the breadcrumb, the
 * Share dialog, or the board/list scope teleports the user back to the
 * previous workflow. The router location pathname always reflects the current
 * URL, so derive the id from it.
 */
export function useWorkflowId(): string | undefined {
  const pathname = useRouterState({
    select: (s) => s.location.pathname,
  });
  return useMemo(() => WORKFLOW_RE.exec(pathname)?.[1], [pathname]);
}
